export function getWebAppBaseUrl(baseOverride?: string): string {
  if (baseOverride?.trim()) return baseOverride.trim().replace(/\/+$/, '')

  const baseFromEnv = (import.meta.env.VITE_APP_BASE_URL as string | undefined)?.trim()
  return baseFromEnv && baseFromEnv.length > 0
    ? baseFromEnv.replace(/\/+$/, '')
    : window.location.origin
}

export function buildWebInviteLink(tokenOrCode: string, baseOverride?: string): string {
  const base = getWebAppBaseUrl(baseOverride)

  const encoded = encodeURIComponent(tokenOrCode)
  return `${base}/invite/${encoded}`
}

export function buildWebInviteMessage(tokenOrCode: string, baseOverride?: string): string {
  const appUrl = getWebAppBaseUrl(baseOverride)
  const inviteUrl = buildWebInviteLink(tokenOrCode, appUrl)

  return [
    'Вход в приложение LEVITA',
    '',
    'Для первого входа откройте ссылку-приглашение:',
    inviteUrl,
    '',
    'Для следующих входов используйте постоянный адрес:',
    appUrl
  ].join('\n')
}
